<div class="sp-card_wrapper card-bg-color cursor-pointer w-full rounded-lg p-6 pt-4 drop-shadow-xl" (click)="detailsView(cardData)">
  <div class="sp-card_main card-content pt-2">
    <p class="text-red-700 text-sm truncate">#{{ cardData?.type ? cardData?.type : cardData?.taskType }}</p>
    <h4 class="sp-card_headline leading-5 text-lg font-bold mb-2">
      {{ cardData?.name ? cardData?.name : ' ' }}
    </h4>
    <div class="sp-card_details items-center pb-2 text-sm h-8 truncate">
      <span class="sp-card_details_label inline-block">{{ cardData?.type ? cardData?.type : cardData?.taskType }} ends:</span>
      <time class="sp-card_details_value inline-block font-bold pl-3" [colorifyDate]="{deadline: cardData?.deadline, colname: 'deadline'}">
        {{ cardData?.deadline ? (cardData?.deadline | spDateFormat : { dayOfWeek: true }) : '' }}
      </time>
    </div>
  </div>
  <div class="card-footer sp-card_footer flex flex-row justify-between items-center justify-start pt-4">
    <div *ngIf="members && members.length" class="flex flex-row flex-wrap gap-2">
      <p *ngFor="let member of members" class="h-8 w-8 rounded-full inline-block">
        <sp-avatar [user]="member" [size]="member.avatarSize" [fontSize]="member.avatarFontSize" [showToolTip]="showNameToolTip"></sp-avatar>
      </p>
    </div>
    <div *ngIf="members && !members.length" class="h-8 w-8 rounded-full inline-block">
      <div class="relative w-12 h-12">
        <sp-avatar [user]="this.loggedInUser" [size]="avatarSize" [fontSize]="avatarFontSize" [showToolTip]="showNameToolTip"> </sp-avatar>
      </div>
    </div>
    <div class="flex flex-row justify-self-end font-bold">
      <p class="border border-solid border-gray-200 rounded-3xl px-4 py-2 text-xs justify-self-end">
        {{ cardData?.status ? cardData?.status : '' }}
      </p>
    </div>
  </div>
</div>
